
const myArray = {

	/**
	 * Deep clone a multi dimensional array.
	 *
	 * @param {array} arr The array to deep clone.
	 * @return {array}
	 */
	clone: function( arr ) {

		// Quickly duplicate the current array creating a new array.
		// @see https://stackoverflow.com/a/5024103/1904139
		let newArr = arr.slice( 0 );

		for ( let i = 0; i < newArr.length; i++ ) {
			// If array then recursively clone.
			// Arrays are of type `object`.
			if ( 'object' === typeof newArr[ i ] ) {
				newArr[ i ] = myArray.clone( newArr[ i ] );
			}
		}

		return newArr;

	},


	/**
	 * Create a unique array.
	 *
	 * @param {array} arr The array to make unique.
	 * @return {array}
	 */
	unique: function( arr ) {

		return [ ...new Set( arr ) ];

	},

};


// const test = [
// 	0,
// 	[ 1, 2, 3 ],
// 	[ 4, 5, 6 ],
// 	7,
// 	8
// ];

// console.log( myArray.clone( test ) );
